import React from 'react';
import { Link } from 'gatsby';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { isMobile } from 'react-device-detect';
import { Menu, XCircle } from 'react-feather';

import { HOME_PATH, RECIPES_PATH, EVENTS_PATH, COACHING_PATH, WHO_AM_I_PATH } from '../../constants/Routes';

import { MobileMenu, MobileOpenMenu, DesktopMenu, Logo } from './style';

const DefaultMenu = () => (
  <div>
    <li>
      <Link className="top-menu-link" to={HOME_PATH}>Home</Link>
    </li>

    <li>
      <Link className="top-menu-link" to={RECIPES_PATH}>Receitas</Link>
    </li>

    <li>
      <Link className="top-menu-link" to={EVENTS_PATH}>Eventos</Link>
    </li>

    <li>
      <Link className="top-menu-link" to={COACHING_PATH}>Coaching</Link>
    </li>

    <li>
      <Link className="top-menu-link" to={WHO_AM_I_PATH}>Quem sou</Link>
    </li>
  </div>
);

class Header extends React.Component {
  state = {
    menuOpen: false
  }

  render() {
    const { menuOpen } = this.state;

    return (
      <div>
        {menuOpen &&
          <MobileMenu>
            <div
              className="close-menu"
              onClick={() => this.setState({ menuOpen: false })}
            >
              <XCircle color="#fff" />
            </div>
            <DefaultMenu />
          </MobileMenu>
        }

        <Grid>
          <Row>
            <Col md={4} xs={7}>
              <Logo to={HOME_PATH}>
                Na Caverna <br /> da Marta
              </Logo>
            </Col>

            <Col md={8} xs={5}>
              {isMobile ?
                <MobileOpenMenu onClick={() => this.setState({ menuOpen: true })}>
                  <Menu />
                </MobileOpenMenu>
              :
              <DesktopMenu>
                <DefaultMenu />
              </DesktopMenu>
              }
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
};

export default Header;
